(function ($) { 

  Drupal.behaviors.homeTeaserStageBuilding = {
	    attach: function (context) {
	    		Drupal.behaviors.homeTeaserStageBuildingCreator(context);
	    }
};
  
  Drupal.behaviors.homeTeaserStageBuildingCreator = function (context){
		$(".homeTeaserStageBuilding", context).each(function (index){    			
			var mainContent = $(this);
			var footerNavText = $(mainContent).data("footer-nav");
			var imagePath = $(mainContent).data("image-path");
			var imageAlt = $(mainContent).data("image-alt");
			
			
	    	var isAlreadyModified = $(mainContent).data("saph-done");
	    	if(isAlreadyModified){
	    		return true;
	    	}
	    	$(mainContent).height($(window).height());

  		$(".homeTeaserMain",mainContent).addClass("main-content-offset fullHeight position-relative");
  		$(".homeTeaserTextMain",mainContent).addClass("fullHeight");
  		$(".homeTeaserImageWrapper",mainContent).addClass("row fullHeight fullWidth");
  		
  		$(".homeTeaserImageWrapper",mainContent).append('<div class="homeTeaserMainImageMask position-relative">\
			<div class="homeTeaserStageBuildingImagesArea fullWidth position-absolute"></div></div>');
		
  		var opacity;
		for (index = 0; index < 2; index++) {
			opacity = 1;
			if(index == 0){
				opacity = 0.28;
			}
			$(".homeTeaserStageBuildingImagesArea",mainContent).append('\
					<div class="homeTeaserStageBuildingImageRect' + (index + 1) + ' homeTeaserStageBuildingImage" style="background-image:url(' + imagePath + '); opacity:' + opacity + '"></div>');
			
			$(mainContent).append('<div class="animatedImage' + (index + 1) + '  homeTeaserStageBuildingAnimatedImage reveal-animate" style="\
					background-image:url(' + imagePath + '); opacity:' + opacity + '\
			"></div>');
			 
		}
  		
  		Drupal.behaviors.calcHomeTeaserStageBuilding(mainContent);
		//And Everytime the user resizes the window
		$(window).resize(function() {
			$(mainContent).height($(window).height());
			Drupal.behaviors.calcHomeTeaserStageBuilding(mainContent);
		});

		$(mainContent).addClass("overflow-hidden");
		
		/*
		$(mainContent).data("animation-type","AboveToCenter");
		Drupal.behaviors.homeTeaserStageBuildingScroll();
		*/

		$(mainContent).data("saph-done",true);

		$(mainContent).ready(function(){
			//Drupal.behaviors.functions.initOnScreenAnimations(".homeTeaserStageBuilding");
  		});	  
  	});	  
  }  
  
	Drupal.behaviors.calcHomeTeaserStageBuilding = function (mainContent) {
		var fullHeight = $(mainContent).height();
		var fullWidth = $(mainContent).width();
		var textSectionTop;
		var bottomPositionLimit;
		var saphNavHeaderHeight = Drupal.behaviors.maxHeightOfNavBar();//$(".saphNavHeader").first().height();
		var imageSectionWidth = $(".homeTeaserMainImageMask",mainContent).width();
		var textPortraitBottomOffset = 70;
		//textSectionTop = $(".homeTeaserStageBuildingTextSection",mainContent).position().top;


		//Drupal.behaviors.functions.consolog("Artist Residency Calc");
		
		$(".homeTeaserStageBuildingImagesArea",mainContent).css("top",0);
		$(".homeTeaserStageBuildingImagesArea",mainContent).css("bottom",0);
		$(".homeTeaserStageBuildingImagesArea",mainContent).css("left",0);
		$(".homeTeaserStageBuildingImagesArea",mainContent).css("right",0);
		
		var actualHeight;
		
		if(Drupal.behaviors.isPortraitMode()){
			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserStageBuildingSubHeadline",mainContent).removeClass("h3-no-change h1");
				//$(".homeTeaserStageBuildingSubHeadline",mainContent).addClass("h3-no-change");
				
				$(".homeTeaserStageBuildingHeadline span",mainContent).removeClass("h1-hero");
				$(".homeTeaserStageBuildingHeadline span",mainContent).addClass("h2");
			}else{
				$(".homeTeaserStageBuildingSubHeadline",mainContent).removeClass("h3-no-change h1");
				$(".homeTeaserStageBuildingSubHeadline",mainContent).addClass("h1");
				
				$(".homeTeaserStageBuildingHeadline span",mainContent).addClass("h1-hero");
				$(".homeTeaserStageBuildingHeadline span",mainContent).removeClass("h2");
			}
			$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-10 col-xs-offset-1");
			$(".homeTeaserMainImageMask",mainContent).removeClass("col-xs-offset-6 col-xs-6");
			$(".homeTeaserStageBuildingTextSection",mainContent).addClass("col-xs-12");
			$(".homeTeaserStageBuildingTextSection",mainContent).removeClass("col-xs-6");
			
			//textSectionTop = $(".homeTeaserStageBuildingTextSection",mainContent).height();
			
			textSectionHeight = $(".homeTeaserStageBuildingTextSection",mainContent).height();	
			$(".homeTeaserStageBuildingTextSection",mainContent).css("top",fullHeight-textSectionHeight-textPortraitBottomOffset);
			textSectionTop = $(".homeTeaserStageBuildingTextSection",mainContent).position().top;
			actualHeight = fullHeight-saphNavHeaderHeight-70 - textSectionHeight;
			$(".homeTeaserMainImageMask",mainContent).height(actualHeight);
		}else{
			if(fullWidth <= 414 || fullHeight <= 414){
				$(".homeTeaserStageBuildingSubHeadline",mainContent).removeClass("h3-no-change h1");
				$(".homeTeaserStageBuildingSubHeadline",mainContent).addClass("h3-no-change");
				
				$(".homeTeaserStageBuildingHeadline span",mainContent).removeClass("h1-hero");
				$(".homeTeaserStageBuildingHeadline span",mainContent).addClass("h2");
			}else{
				$(".homeTeaserStageBuildingSubHeadline",mainContent).removeClass("h3-no-change h1");
				$(".homeTeaserStageBuildingSubHeadline",mainContent).addClass("h1");
				
				$(".homeTeaserStageBuildingHeadline span",mainContent).addClass("h1-hero");
				$(".homeTeaserStageBuildingHeadline span",mainContent).removeClass("h2");
			}
			$(".homeTeaserMainImageMask",mainContent).removeClass("col-xs-10 col-xs-offset-1");
			$(".homeTeaserMainImageMask",mainContent).addClass("col-xs-offset-6 col-xs-6");
			$(".homeTeaserStageBuildingTextSection",mainContent).removeClass("col-xs-12");
			$(".homeTeaserStageBuildingTextSection",mainContent).addClass("col-xs-6");
			
			//textSectionTop = $(".homeTeaserStageBuildingTextSection",mainContent).position().top;
			textSectionHeight = $(".homeTeaserStageBuildingTextSection",mainContent).height();	
			$(".homeTeaserStageBuildingTextSection",mainContent).css("top",fullHeight-textSectionHeight-textPortraitBottomOffset);
			textSectionTop = $(".homeTeaserStageBuildingTextSection",mainContent).position().top;
			actualHeight = fullHeight-saphNavHeaderHeight-70;
			$(".homeTeaserMainImageMask",mainContent).height(actualHeight);
		}
		
		/*
		if(Drupal.behaviors.globalVariables.currentMediaType == "Handheld"){
			$(".homeTeaserStageBuildingSubHeadline",mainContent).removeClass("h3-no-change h1");
			$(".homeTeaserStageBuildingSubHeadline",mainContent).addClass("h3-no-change");
			textSectionTop = $(".homeTeaserStageBuildingTextSection",mainContent).position().top;
			actualHeight = textSectionTop-saphNavHeaderHeight-30-60;
			$(".homeTeaserMainImageMask",mainContent).height(actualHeight);			
		}else if(Drupal.behaviors.globalVariables.currentMediaType == "Something else"){
			$(".homeTeaserStageBuildingSubHeadline",mainContent).removeClass("h3-no-change h1");
			$(".homeTeaserStageBuildingSubHeadline",mainContent).addClass("h1");
			textSectionTop = $(".homeTeaserStageBuildingTextSection",mainContent).position().top;
			actualHeight = textSectionTop-saphNavHeaderHeight-30-30;
			$(".homeTeaserMainImageMask",mainContent).height(actualHeight);
		}else{
			$(".homeTeaserStageBuildingSubHeadline",mainContent).removeClass("h3-no-change h1");
			$(".homeTeaserStageBuildingSubHeadline",mainContent).addClass("h1");
			textSectionTop = $(".homeTeaserStageBuildingTextSection",mainContent).position().top;
			actualHeight = fullHeight-saphNavHeaderHeight-30-120;
			$(".homeTeaserMainImageMask",mainContent).height(actualHeight);
		}
		*/
		//$(".homeTeaserMainImageMask",mainContent).css("top",saphNavHeaderHeight + 30);
		$(".homeTeaserMainImageMask",mainContent).css("top",saphNavHeaderHeight);
		
		//Default size
		/*
		 * Window
		 * width 1005
		 * height 888
		 */
		//Drupal.behaviors.functions.consolog("Stage Building Calculate Images");
		
		var ratioW = $(".homeTeaserMainImageMask",mainContent).width()/492;
		var ratioH = actualHeight/691;
		var actualRatio = ratioH;
		if(ratioW<ratioH){
			actualRatio = ratioW;
		}

		$(".homeTeaserStageBuildingImageRect1",mainContent).css("left",87*actualRatio);
		$(".homeTeaserStageBuildingImageRect1",mainContent).css("top",75*actualRatio);
		$(".homeTeaserStageBuildingImageRect1",mainContent).css("width",404*actualRatio);
		$(".homeTeaserStageBuildingImageRect1",mainContent).css("height",615*actualRatio);

		$(".homeTeaserStageBuildingImageRect2",mainContent).css("left",0*actualRatio);
		$(".homeTeaserStageBuildingImageRect2",mainContent).css("top",0*actualRatio);
		$(".homeTeaserStageBuildingImageRect2",mainContent).css("width",404*actualRatio);
		$(".homeTeaserStageBuildingImageRect2",mainContent).css("height",615*actualRatio);
		
		$(".homeTeaserStageBuildingImagesArea",mainContent).width((87*actualRatio) + (404*actualRatio));
		$(".homeTeaserStageBuildingImagesArea",mainContent).height((75*actualRatio) + (615*actualRatio));
		
		//Setup the animatedImages pos and size
		var images = $(mainContent).data("images");
		var positionOfMainContainer = $(mainContent).offset();
		
		for (index = 0; index < 2; index++) {
			$(".animatedImage" + (index + 1),mainContent).css("left", $(".homeTeaserStageBuildingImageRect" + (index + 1),mainContent).offset().left -positionOfMainContainer.left);
			$(".animatedImage" + (index + 1),mainContent).css("top", $(".homeTeaserStageBuildingImageRect" + (index + 1),mainContent).offset().top - positionOfMainContainer.top);
			$(".animatedImage" + (index + 1),mainContent).width($(".homeTeaserStageBuildingImageRect" + (index + 1),mainContent).width());
			$(".animatedImage" + (index + 1),mainContent).height($(".homeTeaserStageBuildingImageRect" + (index + 1),mainContent).height());
			$(".homeTeaserStageBuildingImageRect" + (index + 1),mainContent).addClass("dissappearElement");
		}
		
		
		$(mainContent).append($(".homeTeaserMain",mainContent));
	};  
  
  
	Drupal.behaviors.changeHomeTeaserStageBuildingMode = function () {
		//Drupal.behaviors.functions.consolog("Desktop Home Teaser Stage Building");
		$(".homeTeaserStageBuilding").each(function (index){
			var mainContent = $(this);
			$(mainContent).height($(window).height());
			Drupal.behaviors.calcHomeTeaserStageBuilding(mainContent);
    		});
	};
	
	Drupal.behaviors.animateHomeTeaserStageBuildingAboveToCenter = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();
			
			var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "AboveToCenter" || currentAnimationType == "BelowToCenter"){
				return true;
			}
			
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserStageBuildingAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserStageBuildingImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			if(index+1 == 1){
	    				opacityUsed = 0.28;
	    			}
	    			
	    			$(animatedImageElement).animate({
						top: -$(animatedImageElement).height(),
					    visibility: "hidden",
					    opacity: 0
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
							  visibility: "visible",
							  opacity: opacityUsed
						  }, animationTime, function() {
						    // Animation complete.
						  });
					  });
			});
    		//});
	};
	Drupal.behaviors.animateHomeTeaserStageBuildingCenterToAbove = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();

		var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "CenterToBelow" || currentAnimationType == "CenterToAbove"){
				return true;
			}
			
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserStageBuildingAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserStageBuildingImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			if(index+1 == 1){
	    				opacityUsed = 0.28;
	    			}
	    			
	    			$(animatedImageElement).animate({
	    					top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
					    visibility: "visible",
					    opacity: opacityUsed
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: -$(animatedImageElement).height(),
							  visibility: "hidden",
							  opacity: 0
						  }, animationTime, function() {
						    // Animation complete.

						  });
					  });
			});
    		//});
	};	
	
	Drupal.behaviors.animateHomeTeaserStageBuildingBelowToCenter = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();

			var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "AboveToCenter" || currentAnimationType == "BelowToCenter"){
				return true;
			}
			
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserStageBuildingAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserStageBuildingImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			if(index+1 == 1){
	    				opacityUsed = 0.28;
	    			}
	    			
	    			$(animatedImageElement).animate({
	    					top: $(mainContent).height(),//$(animatedImageElement).height(),
					    visibility: "hidden",
					    opacity: 0
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
							  visibility: "visible",
							  opacity: opacityUsed
						  }, animationTime, function() {
						    // Animation complete.

						  });
					  });
			});
    		//});
	};	

	Drupal.behaviors.animateHomeTeaserStageBuildingCenterToBelow = function (mainContent) {
		//Initial position
		var transitionEvent = Drupal.behaviors.whichTransitionEvent();
		
			var currentAnimationType = $(mainContent).data("animation-type");
			if(currentAnimationType == "CenterToBelow" || currentAnimationType == "CenterToAbove"){
				return true;
			}
			
			var positionOfMainContainer = $(mainContent).offset();
			$(".homeTeaserStageBuildingAnimatedImage",mainContent).each(function (index){
				
	    			var animatedImageElement = $(this);
	    			var sourceAnimatedElement = $(".homeTeaserStageBuildingImageRect" + (index + 1),mainContent);
	    			var opacityUsed = 1;
	    			var animationTime = 300 + (100 * index);
	    			if(index+1 == 1){
	    				opacityUsed = 0.28;
	    			}
	    			
	    			$(animatedImageElement).animate({
	    					top: $(sourceAnimatedElement).offset().top - positionOfMainContainer.top,
					    visibility: "visible",
					    opacity: opacityUsed
					  }, 10, function() {
						  $(animatedImageElement).animate({
							  top: $(mainContent).height(),//$(animatedImageElement).height(),
							  visibility: "hidden",
							  opacity: 0
						  }, animationTime, function() {
						    // Animation complete.
							  
						  });
					  });
			});
    		//});
	};	

	Drupal.behaviors.homeTeaserStageBuildingScroll = function () {
		return true; //No animations for now
		var lastScrollTop = 0, delta = 5;
		$(window).scroll(function() {
			var elmentScrollPoint;
			var scrollTop = $(this).scrollTop();
			var scrollBottom = scrollTop + $(window).height();

			$(".homeTeaserStageBuilding").each(function (index){
				//Get center position
				var mainContent = $(this);
				var elementHeight = $(mainContent).height();
				var scrollPositionOfElement = $(mainContent).offset().top;
				var elementCenterPosition = scrollPositionOfElement + (elementHeight/2);
				var elementEndPosition = scrollPositionOfElement + elementHeight;
				
				if(Math.abs(lastScrollTop - scrollTop) <= delta){
					return true;
				}
			    var isDownDir;
				if (scrollTop > lastScrollTop){
					//downscroll code
					isDownDir = true;
				} else {
					//upscroll code
					isDownDir = false;
				}
				
				
				if(!isDownDir && scrollTop < elementCenterPosition && scrollBottom > elementEndPosition){
					Drupal.behaviors.animateHomeTeaserStageBuildingAboveToCenter(mainContent);
					$(mainContent).data("animation-type","AboveToCenter");				
				}else if (isDownDir && scrollTop > elementCenterPosition && scrollBottom > elementEndPosition){
					Drupal.behaviors.animateHomeTeaserStageBuildingCenterToAbove(mainContent);
					$(mainContent).data("animation-type","CenterToAbove");					
				}else if (isDownDir && scrollBottom > elementCenterPosition){
					Drupal.behaviors.animateHomeTeaserStageBuildingBelowToCenter(mainContent);
					$(mainContent).data("animation-type","BelowToCenter");
				}else if (!isDownDir && scrollBottom < elementCenterPosition){
					Drupal.behaviors.animateHomeTeaserStageBuildingCenterToBelow(mainContent);
					$(mainContent).data("animation-type","CenterToBelow");
				}
			});
			lastScrollTop = scrollTop;
		});
	}

	
	

})(jQuery);